

import React, { memo } from 'react';
import cx from 'classnames';
import { COMMENT_VISIBILITY_STYLES } from '../../../constants/commentVisibilityStyles';

import '../styles/_comment-button.scss';














function CommentButton({
  onClick,
  colour,
  number,
  selected,
  isV2Design,
  selectedCommentId,
  metadata
}) {
  const userSpecificColorBrightness = Number(colour.brightness.replace(/[^\d]/g, ''));
  const { visibility } = JSON.parse(metadata || '{}');

  const colorBrightness = selectedCommentId && isV2Design && !selected ? `brightness(${userSpecificColorBrightness * 0.6}%)` : colour.brightness;
  const backgroudColor = isV2Design && visibility ?
  COMMENT_VISIBILITY_STYLES[visibility]?.bgColor :
  colour.color;

  return (
    <button
      className={cx('comment-button', { 'comment-button--selected': selected })}
      style={{
        backgroundColor: selected ? '#27baa1' : backgroudColor,
        filter: selected ? 'none' : colorBrightness,
        position: 'absolute'
      }}
      type="button"
      onClick={onClick}>

      {number}
    </button>);

}

export default memo(CommentButton);